// @flow

import * as actions from 'client/constants/actions';

export function updateSelected(selectedItems: GalleryItems): any {
	return {
		type: actions.ADD_SELECTED_ITEMS,
		payload: selectedItems,
	};
}
